const colors = {
  cardBackground: '#FFFFFF',
  clear: 'rgba(0,0,0,0)',
  transparent: 'rgba(0,0,0,0)',
  silver: '#F7F7F7',
  steel: '#CCCCCC',
  error: 'rgba(200, 0, 0, 0.8)',
  ricePaper: 'rgba(255,255,255, 0.75)',
  frost: '#D8D8D8',
  cloud: 'rgba(200,200,200, 0.35)',
  windowTint: 'rgba(0, 0, 0, 0.4)',
  panther: '#161616',
  charcoal: '#595959',
  coal: '#2d2d2d',
  bloodOrange: '#fb5f26',
  snow: 'white',
  ember: 'rgba(164, 0, 48, 0.5)',
  fire: '#e73536',
  drawer: 'rgba(30, 30, 29, 0.95)',
  eggplant: '#251a34',
  banner: '#5F3E63',
  text: '#E0D7E5',
  red: 'rgb(255,0,0)',
  vfRed: 'rgb(230, 0, 0)',
  vfRedRGBA: (alpha = 1) => `rgba(230, 0, 0, ${alpha})`,
  border: '#dddddd',
  white: 'rgb(255, 255, 255)',
  brownGrey: 'rgb(153, 153, 153)',
  black: 'rgb(51, 51, 51)',
  ocean: 'rgb(0, 124, 146)',
  oceanRGBA: (alpha = 1) => `rgba(0, 124, 146, ${alpha})`,
  brownishGrey: 'rgb(102, 102, 102)',
  blackTwo: 'rgb(51, 51, 51)',
  veryLightPink: 'rgb(204, 204, 204)',
  mustardGreen: 'rgb(168, 182, 0)',
  mustardGreenRGBA: (alpha = 1) => `rgba(168, 182, 0, ${alpha})`,
  darkGrassGreen: 'rgb(66, 134, 0)',
  darkGrassGreenRGBA: (alpha = 1) => `rgba(66, 134, 0, ${alpha})`,
  marigold: 'rgb(254, 203, 0)',
  marigoldRGBA: (alpha = 1) => `rgba(254, 203, 0, ${alpha})`,
  tangerine: 'rgb(235, 151, 0)',
  tangerineRGBA: (alpha = 1) => `rgba(235, 151, 0, ${alpha})`,
  brownGreyTwo: 'rgb(151, 151, 151)',
  veryLightPinkTwo: 'rgb(235, 235, 235)',
  overlay: 'rgba(0,0,0,0.6)',
  veryLightPinkTwoRGBA: (alpha = 1) => `rgba(235, 235, 235,${alpha})`,
  babyBlue: 'rgb(0, 22, 230)',
  babyBlueRGBA: (alpha = 1) => `rgba(0, 22, 230, ${alpha})`,
  babyBlue2: 'rgb(0, 22, 255)',
  babyBlue2RGBA: (alpha = 1) => `rgba(0, 22, 255, ${alpha})`,
  grey40: '#666666',
  icGreyStep: 'rgba(0, 0, 0, 0.5)',
  linegrey: 'rgba(0, 0, 0, 0.16)',
  blackLabel: '#333333',
  blackThree: '#000000',
  warm_grey_two: '#999999',
  shadow: 'rgba(0, 0, 0, 0.2)',
  whiteSmoke: '#f4f4f4',

  font: '#333333',
  font_red: '#e60000',
  background: '#eceff0',
  light_black: '#13273a',

  //Primary:
  grey: '#4A4D4E',

  //Secondary:
  turquoise: '#007C92',
  aqua_blue: '#00B0CA',
  aubergine: '#5E2750',
  red_violet: '#9C2AA0',
  spring_green: '#A8B400',
  fresh_orange: '#EB9700',
  lemon_yellow: '#FECB00',

  //Digital:
  ui_green: '#009900',
  maroon: '#990000',

  //Grey:
  dark_grey: '#333333',
  anthracite: '#666666',
  mid_grey: '#999999',
  platinum: '#AFAFAF',
  aluminium: '#EBEBEB',
  light_grey: '#F4F4F4',

  //Other:
  dark_red: '#6c0000',
  opacity: '#040406',
  red_gradient_start: '#e60000',
  red_gradient_end: '#820000',

  lightGray: 'rgba(51, 51, 51, .2)',
  halfGray: 'rgba(51, 51, 51, .5)',
  darkGray: 'rgba(51, 51, 51, .8)'
}

export default colors
